export const PRODUCT_COMPARISON_DURABILITY_FIELDS = [
  'year_date_release',
  'last_os_compatibility',
  'os',
  'macbook_maximum_os_supported',
  'foldable',
  'ipad_maximum_os',
]

export const PRODUCT_COMPARISON_PERFORMANCE_FIELDS = [
  'memory',
  'processor',
  'processor_type',
  'ipad_processor',
  'graphic_card',
  'macbook_architecture',
]

export const PRODUCT_COMPARISON_SCREEN_QUALITY_FIELDS = [
  'resolution',
  'ips',
  'macbook_brightness',
  'macbook_screen_type',
  'macbook_true_tone',
  'promotion',
  'retina',
  'screen_type',
  'pixel_density',
  'ipad_brightness',
  'display_glass',
]

export const PRODUCT_COMPARISON_SOUND_QUALITY_FIELDS = ['ipad_speakers']

export const PRODUCT_COMPARISON_MULTIMEDIA_FIELDS = [
  'macbook_front_camera_video_definition',
  'macbook_speakers',
]

export const PRODUCT_COMPARISON_CAMERA_FIELDS = ['main_camera', 'front_camera']

export const PRODUCT_COMPARISON_MISCELANEOUS_FIELDS = [
  'touch_bar',
  'hdmi_output',
  'face_id',
  'touch_id',
  'ipad_connector',
  'connector',
]
